<style lang="scss">
.mesmonitorMachineMoldTable .el-progress-bar__outer {
  background: #606672;
}

.mesmonitorMachineMoldTable .el-progress__text {
  color: #ffffff;
}

.mesmonitorMachineMoldTable::before {
  z-index: inherit;
}

.mesmonitorMachineMoldTable.el-table {
  background-color: transparent;
}

.mesmonitorMachineMoldTable.el-table--border:after,
.mesmonitorMachineMoldTable.el-table--group:after,
.mesmonitorMachineMoldTable.el-table:before {
  background-color: transparent;
}

.mesmonitorMachineMoldTable.el-table tr {
  background-color: transparent;
}

.mesmonitorMachineMoldTable.el-table--enable-row-hover .el-table__body tr:hover > td {
  background-color: rgba(7, 53, 245, 1) !important;
}

.mesmonitorMachineMoldTable .el-table td.gutter,
.mesmonitorMachineMoldTable.el-table th.gutter {
  background: rgba(7, 53, 245, 1) !important;
}

//.mesmonitorMachineMoldTable .el-table__body-wrapper {
//  background: #1d1d24;
//}

// 滚动条的宽度
.mesmonitorMachineMoldTable .el-table__body-wrapper::-webkit-scrollbar {
  width: 2px; // 横向滚动条
}

// 滚动条的滑块
.mesmonitorMachineMoldTable .el-table__body-wrapper::-webkit-scrollbar-thumb {
  background-color: #419fff;
  border-radius: 2px;
}

/*滚动条里面轨道*/
// .mesmonitorMachineMoldTable .el-table__body-wrapper::-webkit-scrollbar-track {
// 	border-radius: 2px;
// 	background: #1D1D24;
// }
</style>
<style lang="scss" scoped="scoped">
.cell-class-name {
  border-bottom: 1px solid red !important;
}
.biankuang {
  border: 4px solid rgba(108, 167, 255, 1);
  border-radius: 5px;
  box-shadow: 0px 0px 30px 0px rgba(45, 53, 255, 1) inset;
  box-shadow: 0px 0px 80px 0px rgba(45, 53, 255, 1) inset;
}

.yongxinSmallTitle {
  background-image: url(../../../../../../../assets/img/web/yongxin/small_title_bg.png);
  background-size: 100% 100%;
  background-repeat: no-repeat;
}
</style>

<template>
  <div ref="container" style="overflow: auto;height: 100%;position: relative;padding: 20px 20px 0px 10px; background: rgba(3, 0, 108, 1)">
    <div class="biankuang">
      <div ref="titleBar" class="titleBar" style="display: flex;justify-content: space-between;align-items:center ;padding-bottom: 10px;">
        <div class="yongxinSmallTitle" style="width: 100%;height: 40px;color:white;display:flex;justify-content:center;align-items:center;font-size:20px">
          待保养/保养中任务
        </div>
      </div>
      <div :style="{ height: contentHeight + 'px' }" style="padding: 0px 16px;">
        <el-table ref="table" class="mesmonitorMachineMoldTable" :data="list" style="width: 100%" :max-height="contentHeight" :row-style="{ height: rowHeight + 'px' }" :cell-style="{ padding: 0 + 'px', borderColor: 'rgba(7, 53, 245, 1)', color: '#FFFFFF', 'font-size': '16px' }" :header-cell-style="{ background: 'rgba(7, 53, 245, 1)', color: 'white', padding: '0px', height: '42px', borderColor: 'transparent', 'font-size': '16px' }" cell-class-name="cell-class-name">
          <el-table-column prop="equipmentSn" :label="$t('设备编号')"> </el-table-column>
          <el-table-column prop="equipmentName" :label="$t('设备名称')"> </el-table-column>
          <!-- <el-table-column :label="$t('guzhangmiaoshu')">
            <template slot-scope="scope">
              <div style="font-size: 16px;font-weight: bold;">
                {{ $t(scope.row.description) }}
              </div>
            </template>
          </el-table-column> -->

          <el-table-column :label="$t('计划保养日期')">
            <template slot-scope="scope">
              <div style="font-size: 16px;font-weight: bold;">
                {{ dayjs.unix(scope.row.planTime / 1000).format('YYYY-MM-DD') }}
              </div>
            </template>
          </el-table-column>
          <el-table-column :label="$t('保养人')">
            <template slot-scope="scope">
              <div style="font-size: 16px;font-weight: bold;">
                {{ $t(scope.row.maintainer) }}
              </div>
            </template>
          </el-table-column>

          <el-table-column :label="$t('保养状态')">
            <template slot-scope="scope">
              <div style="font-weight: bold;font-size: 15px;border-radius: 2px;height: 30px;width: 76px;display: flex;justify-content: center;align-items: center;border:1px solid rgba(255, 58, 94, 1)" :style="{ color: textColor[scope.row.maintainStatus], 'border-color': textColor[scope.row.maintainStatus], 'background-color': bgColor[scope.row.maintainStatus] }">
                {{ $t({ '1': 'weibaoyang', '2': 'baoyangzhong', '3': 'daibaoyang' }[scope.row.maintainStatus]) }}
              </div>
            </template>
          </el-table-column>
          <!-- <el-table-column :label="$t('jinjichengdu')">
            <template slot-scope="scope">
              <div :style="{ 'background-color': { '1': 'rgba(250, 186, 20, 1)', '2': 'rgba(250, 108, 28, 1)', '3': 'rgba(245, 34, 45, 1)' }[scope.row.level] }" style="font-weight: bold;font-size: 14px;border-radius: 2px;height: 30px;width: 76px;display: flex;justify-content: center;align-items: center;color:white;">
                {{ $t({ '1': 'yiban', '2': 'jinji', '3': 'teji' }[scope.row.level]) }}
              </div>
            </template>
          </el-table-column> -->
        </el-table>
      </div>
    </div>
  </div>
</template>
<script type="text/javascript">
export default {
  name: 'web_monitor_machine_model_machine_wait',
  components: {},
  watch: {
    '$attrs.orgId'(newValue, oldValue) {
      if (this.utils.isEqual(newValue, oldValue)) {
        return;
      }
      this.listData();
    }
  },
  data() {
    return {
      textColor: { '1': 'rgba(255, 58, 94, 1)', '2': 'rgba(57, 241, 109, 1)', '3': 'rgba(255, 200, 58, 1)' },
      bgColor: { '1': 'rgba(255, 58, 94, 0.2)', '2': 'rgba(57, 241, 109, 0.2)', '3': 'rgba(255, 200, 58, 0.2)' },

      interval: null,
      timer: null,
      contentHeight: 0,
      rowHeight: 0,
      list: [],

      isStopListScroll: false
    };
  },
  created() {
    this.timer = setInterval(() => {
      this.listData();
    }, 120000);
    this.listData();
  },
  mounted() {
    this.resize();
    this.utils.event_hub.$on('RESIZE', () => {
      this.resize();
    });
    this.setAutoScroll();
  },
  destroyed() {
    if (this.timer) {
      clearInterval(this.timer);
    }
  },
  methods: {
    async listData() {
      let response = await this.http.get('/custom/yongxin/equipment/maintenance/list');
      this.list = response.data;
    },
    setAutoScroll() {
      if (this.interval) {
        clearInterval(this.interval);
      }
      const listDiv = this.$refs.table.bodyWrapper;
      this.interval = setInterval(() => {
        if (!this.store.state.is_monitor_full) {
          return;
        }
        if (!this.isStopListScroll) {
          listDiv.scrollTop += 1 / window.devicePixelRatio + 0.05;
          if (listDiv.clientHeight + listDiv.scrollTop >= listDiv.scrollHeight) {
            this.isStopListScroll = true;
            setTimeout(() => {
              if (listDiv.clientHeight + listDiv.scrollTop >= listDiv.scrollHeight) {
                listDiv.scrollTop = 0;
              }
              this.isStopListScroll = false;
            }, 5000);
          }
        }
      }, 100);
    },
    resize() {
      //因为内容高度也是延迟计算的，这里必须设置延迟比外面Index更延迟
      setTimeout(() => {
        if (!this.$refs.titleBar) {
          return;
        }
        this.contentHeight = this.$refs.container.offsetHeight - this.$refs.titleBar.offsetHeight - 20 - 20;
        this.rowHeight = (this.contentHeight - 42 - 5) / 8;
      }, 800);
    }
  }
};
</script>
